<template>
  <div class="product-list-item d-flex justify-content-center th-p-20 bg-white">
    <div class="product-img-container">
      <img :src="image" />
    </div>
    <div class="product-text-container th-ml-20 th-mt-2">
      <p class="th-fs-18 th-m-0">{{ title }}</p>
      <div class="text-black th-fs-14 th-mt-6">{{ desc }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MobileProductItem',
  props: { title: String, image: String, desc: String },
  setup() {},
}
</script>

<style lang="scss" scoped>
.product-img-container {
  width: 60px;
  height: 60px;
  border: 1px solid #4b7ef6;
  border-radius: 50%;
}

.product-img-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-text-container {
  flex: 1;
}
</style>
